import { writable } from 'svelte/store';
import { post, get, patch } from "../utils/rest";
import { host } from "../utils/config";

const serverURL = `${host}/`;
function createStore() {
	const { subscribe, set, update } = writable([]);

	return {
        subscribe,
        set,
		welcomeMail: async mail => {
			let result = await fetch('https://kalaputriemail.herokuapp.com/clientwelcome', {
                method: 'POST',
                headers: {
                    "Content-type" :  "application/json",
                },
                body: JSON.stringify(mail)
            });
                let data = await result.json();
                update(u => data);
                console.log("rfds"+JSON.stringify(data))
                return data;
        },
        findUser: async username => {
			let result = await fetch('https://www.instagram.com/web/search/topsearch/?context=blended&query='+username+'&rank_token=0.17928032789260828&include_reel=true', {
                mode: 'no-cors',
                headers: {
                    "Content-type" :  "application/json",
                    "Cookie":"ig_did=0F93AE3B-8D66-47DA-BF36-4D5FA8743F6C; ig_nrcb=1; mid=X5xKXQAEAAETZoRx5bfBltlkMeOA; csrftoken=RrPQtr8ZFys7EwB1XeClHzs4KLjhdqyL; ds_user_id=42204396239; sessionid=42204396239%3AQqlj8vU3M01kUd%3A26; fbm_124024574287414=base_domain=.instagram.com; shbid=17968; rur=ATN; shbts=1620709761.483645; fbsr_124024574287414=0hl6HcWFcuoZcvke2gmwMdFd-TB7CEANFXj_kASnVfo.eyJ1c2VyX2lkIjoiMTAwMDA0NTE2Mjc5MTQzIiwiY29kZSI6IkFRQUlkNlFrOGdPckRrRUVfN19rOEhYR0dJOW52R2ZnaGpXcnpUX3pZSjFFWGJ1TUhrNy05RTBha0xSNXU2a1o3eVllODVlQUFwVFBoZFRJUjZJOE4xcGc1alVIMUdJT3hibGZwZmx6czNWZFA3MHRLRmNLMm9PS2o1Q05SMTgxWmQ1TXViR3NOVXJzWFlzeXRXLVQ5bVp1SWpiWDRTS0drWHNHbVR2V0Q3LXVhalBTaU16SkFudHRVRFhzcHlQdURCZGN2UDhoMFFIWC1oQTd1YmlQMEZQNllENzRTbjZPZmZFY1JaQk5FdHBjUFBRVHhLbGxIYTNEOWNJV3cyWmVHNjFxTDdCZzZpZjlmeDItMnZrTjZnTnAwLVdPSVhYOGF6WGtOS1A3c1pWX1FEUVBlcUZieTgwRnRkUmp6aXg1VEt3N3UwS2F0cEZBTG1LMnBaRkJVTXVJIiwib2F1dGhfdG9rZW4iOiJFQUFCd3pMaXhuallCQUlJWkJaQXUzWkNrWkJaQk1EQkpFQkZqZkRuaFJIaEc4dE1rM3BIbEs1VEpJUlhiYk1Hb0JNY0xZclZjelVnU2xPcU4xNmprUU8xdGdpMGFSQlJlNE9ST0w0b1E2WkNBbUJMVHZHUkMxdGh0clBGQmdxVjRQWkFGUW5pN0RwOFFIMDdaQ05zMENWNVlHWkJUUTMyRmI2NWZGSm9mZWlMYTZVRklEdWZkdjExREEiLCJhbGdvcml0aG0iOiJITUFDLVNIQTI1NiIsImlzc3VlZF9hdCI6MTYyMDgwODg2Mn0",
                    "Authorization":"Bearer EAABwzLixnjYBACyZA5YwwQ9mDtGNizQXqyknoDPWFQUnYYcjKml7UCTZBwQWLEsmkdI9RWwFZCd4bNYwqGEZAWhTUuWiFfU6LZCRbuGFjFY1dVDYvzeQRtnWf1UGNEIZBAP6ywfgerRUra9Ce0EqFZAl2uDzkEwZBvbVqjjWzBb3FnsZAg92aIw6K"
                }
            });
                let data = await result;
                update(u => data);
                console.log("instaname"+JSON.stringify(data))
                return data;
        },

        getPaperType: async () => {
             return new Promise((reslove,reject)=>{
                 get('papertypes/', function(err,res){
                    let data = res;
                    console.log("papertypes::"+JSON.stringify(data));
                    update(u => data);
                    reslove(data);
                })
             }) 
            
        },
       getArtType: async () => {
            return new Promise((reslove,reject)=>{
                    get('arttypes/', function(err,res){
                    let data = res;
                    console.log("arttypes::"+JSON.stringify(data));
                    update(u => data);
                    reslove(data);
                })
            }) 
        },
        getAdditionalFaces: async () => {
            return new Promise((reslove,reject)=>{
                    get('additionalfaces/', function(err,res){
                    let data = res;
                    console.log("additionalfaces::"+JSON.stringify(data));
                    update(u => data);
                    reslove(data);
                })
            }) 
        }, 
        getDelivery: async () => {
            return new Promise((reslove,reject)=>{
                    get('deliveryareas/', function(err,res){
                    let data = res;
                    console.log("deliveryareas::"+JSON.stringify(data));
                    update(u => data);
                    reslove(data);
                })
            }) 
        },
        getOrders: async () => {
            return new Promise((reslove,reject)=>{
                    get('orderbookings/', function(err,res){
                    let data = res;
                    console.log("orderbookings::::"+JSON.stringify(data));
                    update(u => data);
                    reslove(data);
                })
            }) 
        }   
        // delete: async id => {
        //     let res = await fetch(`http://localhost:3000/blogs/${id}`, {
        //         method: 'DELETE',
        //         headers: {
        //             "Content-type" :  "application/json"
        //         }
        //     });
        //     res = await res.json();
        //     if(res.status == 'OK'){
        //         let result = await fetch('http://localhost:3000/blogs');
        //         let data = await result.json();
        //         update(u => data);
        //         return true;
        //     }else{
        //         return false;
        //     }
        // }
	};
}

export const orders = createStore();
             orders.getPaperType();
             orders.getArtType();
             orders.getDelivery();
            orders.getAdditionalFaces();
            orders.findUser();
            orders.getOrders();